<template>
	<div class="animated fadeIn">

		<DetailFrame :scenery="scenery">
			<component v-bind:is="scenery.component"></component>
		</DetailFrame>

	</div>

</template>
<script>

	import {MessageBox, Notification} from 'element-ui'
	import Scenery from "../../../common/model/lover/Scenery";
	import DetailFrame from "./widget/DetailFrame.vue";
	export default {

		data () {
			return {
				id: 0
			}
		},
		components: {
			DetailFrame
		},
		computed: {
			"sceneryMap"(){
				return this.$store.state.sceneryMap;
			},
			"scenery"(){
				let s = this.sceneryMap[this.id];
				if (s == null) {
					s = new Scenery();
				}
				return s;
			}
		},
		watch: {},
		methods: {},
		mounted(){

			this.id = parseInt(this.$store.state.route.params.id);

		}
	}

</script>



// WEBPACK FOOTER //
// Detail.vue?174e7746